import React, { createContext, useContext } from "react";

// Default base level (z-index) for the application's modal layer
const DEFAULT_LEVEL = 2400;
const STEP = 100;

export const LevelContext = createContext(DEFAULT_LEVEL);

export const useLevel = () => useContext(LevelContext);

export const LevelProvider = ({ children, base = DEFAULT_LEVEL }) => {
  return (
    <LevelContext.Provider value={base}>{children}</LevelContext.Provider>
  );
};

/**
 * A wrapper that increments the level (z-index) for its children.
 * Use this when creating a new stacking context (like a Modal, Dialog, or Popover).
 */
export const LevelLayer = ({ children, step = STEP }) => {
  const currentLevel = useLevel();
  const nextLevel = currentLevel + step;

  return (
    <LevelContext.Provider value={nextLevel}>
      {children}
    </LevelContext.Provider>
  );
};
